import { ButtonComponentConfig } from '../button';

export interface ActionButtonConfig extends ButtonComponentConfig {
  visible?: boolean;
}
